// extracted by mini-css-extract-plugin
export default {"root":"_3BDYu","heading-and-subheading-block":"_1lR0c","headingAndSubheadingBlock":"_1lR0c","subheading":"_2td7K"};